import { nanoid } from 'nanoid';

const identify = (x: any) => ({
  id: `x${nanoid()}`,
  ...x,
});

export { identify };
